var map = {
	"./common/github.svg": 5614,
	"./common/google.svg": 5282,
	"./company/darupardazan_novin_logo.jpg": 679,
	"./company/nuvei_logo.jpg": 4988,
	"./concordia.png": 9751,
	"./razi-university-logo.png": 7958,
	"./skills/aspdotnet.svg": 3629,
	"./skills/aws.png": 8985,
	"./skills/aws.svg": 6371,
	"./skills/c-sharp.png": 5726,
	"./skills/c-sharp.svg": 260,
	"./skills/database-sql.svg": 6368,
	"./skills/docker.svg": 4936,
	"./skills/javascript.svg": 8109,
	"./skills/microsoft-azure.svg": 1634,
	"./skills/nodejs.svg": 4333,
	"./skills/react.svg": 785,
	"./skills/sql-database-generic.svg": 9606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9945;